import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
// import {connect} from 'react-redux';
// import {initialState} from '../reducers/project-title';
import uploadBlob from '../lib/upload-blob';
import {exportBlock} from '../lib/exportImage';
import debounce from 'lodash.debounce';
/**
 * Project saver component passes a downloadProject function to its child.
 * It expects this child to be a function with the signature
 *     function (downloadProject, props) {}
 * The component can then be used to attach project saving functionality
 * to any other component:
 *
 * <SB3Uploader>{(downloadProject, props) => (
 *     <MyCoolComponent
 *         onClick={downloadProject}
 *         {...props}
 *     />
 * )}</SB3Uploader>
 */
class SB3Uploader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'downloadProject'
        ]);
    }
    componentDidMount (){
        // this.props.onRef(this);
    }

    componentDidUpdate (){
        return false;
    }
    

    async downloadProject (resolve, reject) {
        const cover = exportBlock(true);
        // 修改作品操作，必须要有作品id
        // if (!mataProjectId) {
        //     console.log("修改作品操作，必须要有作品id");
        //     reject("修改作品操作，必须要有作品id");
        //     return;
        // }
        try {
            const {mataProjectId, projectFilename, onSaveFinished} = this.props;
            const content = await this.props.saveProjectSb3();
            if (onSaveFinished) {
                onSaveFinished();
            }
            uploadBlob(
                projectFilename,
                cover,
                content,
                mataProjectId,
                resolve,
                reject
            );
        } catch (error) {
            reject(error);
        }
       
    }

    // 这里返回一个className,和一个上传函数
    render () {
        const {
            children
        } = this.props;
        return children(
            this.props.className,
            debounce(this.downloadProject, 1000)
        );
    }
}

const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.mc`;
};

SB3Uploader.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    projectFilename: PropTypes.string,
    saveProjectSb3: PropTypes.func,
    mataProjectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isNew: PropTypes.bool, // 是否上传一个新的作品
    // onRef: PropTypes.func
};
SB3Uploader.defaultProps = {
    className: '',
    isNew: false
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    // projectFilename: getProjectFilename(state.scratchGui.projectTitle, initialState),
    mataProjectId: state.scratchGui.projectState.mataProjectId
});

// export default connect(
//     mapStateToProps,
//     () => ({}), // omit dispatch prop,
//     null,
//     {withRef: true}
// )(SB3Uploader);
export default SB3Uploader;
